import { GetterTree } from "vuex";
import { IAppState } from "./state";

import {
    IActivationType,
    IActivationCase,
    IMarket,
    IDashboard,
    IRole,
    IEntity,
    IActivation,
    IKeyword,
    IHashtag,
    IBrand,
    IBrandQuality,
    IUser,
    IActivationComment,
    IActivationUser,
    IPrAffiliate,
} from "@/models";

const getters: GetterTree<IAppState, any> = {
    activationtype: (state): IActivationType[] => state.activationType,
    activationcase: (state): IActivationCase[] => state.activationCase,
    dashboard: (state): IDashboard[] => state.dashboard,
    markets: (state): IMarket[] => state.markets,
    roles: (state): IRole[] => state.roles,
    unauthorizeRoles: (state): IRole[] => state.unauthorizeRoles,
    entities: (state): IEntity[] => state.entities,
    brands: (state): IBrand[] => state.brands,
    prAffiliates: (state): IPrAffiliate[] => state.prAffiliates,
    brandsQuality: (state): IBrandQuality[] => state.brandsQuality,
    activations: (state): IActivation[] => state.activations,
    keywords: (state): IKeyword[] => state.keywords,
    hashtags: (state): IHashtag[] => state.hashtags,
    users: (state): IUser[] => state.users,
    activationCreate: (state): number => {
        const ids = state.activationCreate.map(_=>_.activationId);
        return ids[ids.length-1];
    },
    currentActivation: (state): IActivation => state.currentActivation,
    activationComments: (state): IActivationComment[] => state.activationComments,
    influencersTemplate: (state): Blob => state.influencersTemplate,
    influencers: (state): Blob => state.influencers,
    activationUsers: (state): IActivationUser[] => state.activationUsers,
};

export { getters };
